<template>
  <div class="mx-2 mb-2">
    <b-row>

      <!-- Showing -->
      <b-col
        cols="12"
        sm="6"
        class="d-flex align-items-center justify-content-center justify-content-sm-start"
      >
        <span
          v-if="total > 0"
          class="text-muted"
        >{{ $t('Showing from to to of total entries',{from,to,total}) }}</span>
      </b-col>
      <!-- Pagination -->
      <b-col
        v-if="totalPage > 1"
        cols="12"
        sm="6"
        class="d-flex align-items-center justify-content-center justify-content-sm-end"
      >
        <b-pagination
          v-model="page"
          :total-rows="total"
          :per-page="perPage"
          first-number
          last-number
          class="mb-0 mt-2 mt-md-0"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </b-col>
    </b-row>
  </div>

</template>

<script>
import {
  BRow,
  BCol,
  BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'ListPagination',
  components: {
    BRow,
    BCol,
    vSelect,
    BPagination,
  },
  props: {
    current: {
      type: Number,
      default: () => 1,
    },
    currentPerPage: {
      type: Number,
      default: () => 25,
    },
    from: {
      type: Number,
      default: () => 1,
    },
    to: {
      type: Number,
      default: () => 1,
    },
    total: {
      type: Number,
      default: () => 1,
    },
    totalPage: {
      type: Number,
      default: () => 1,
    },
  },
  data() {
    return {
      page: 1,
      perPage: 25,
      perPageOptions: [25, 50, 75, 100, 150, 200, 300, 500, 1000],
    }
  },
  watch: {
    page: 'changePage',
    perPage: 'changePerPage',
    current: 'setPage',
    currentPerPage: 'setPerPage',
  },
  created() {
    this.setPage()
    this.setPerPage()
  },
  methods: {
    setPage() {
      this.page = this.current
    },
    setPerPage() {
      this.perPage = this.currentPerPage
    },
    changePage(page) {
      this.page = page
      this.$router.replace({
        path: this.$route.path,
        hash: this.$route.hash,
        query: { ...this.$route.query, page },
      })
      return this.$emit('onChangePage', page)
    },
    changePerPage(perPage) {
      this.perPage = perPage
      this.$router.replace({
        path: this.$route.path,
        hash: this.$route.hash,
        query: { ...this.$route.query, per_page: perPage },
      })
      return this.$emit('onChangePerPage', perPage)
    },
  },
}
</script>

<style scoped>

</style>
